/**
 * Convert timecode string "HH:MM:SS:FF" to seconds
 * @param {string} timecode - Timecode in format "HH:MM:SS:FF"
 * @param {number} fps - Frames per second (default 24)
 * @returns {number} Time in seconds
 */
export function timecodeToSeconds(timecode, fps = 24) {
    if (timecode == null) {
        return 0;
    }
    if (typeof timecode !== 'string') {
        console.warn('Invalid timecode format:', timecode);
        return 0;
    }

    const parts = timecode.split(':');
    if (parts.length !== 4) {
        console.warn('Invalid timecode format (expected HH:MM:SS:FF):', timecode);
        return 0;
    }

    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    const seconds = parseInt(parts[2], 10) || 0;
    const frames = parseInt(parts[3], 10) || 0;

    return (hours * 3600) + (minutes * 60) + seconds + (frames / fps);
}

/**
 * Convert seconds to timecode string "HH:MM:SS:FF"
 * @param {number} seconds - Time in seconds
 * @param {number} fps - Frames per second (default 24)
 * @returns {string} Timecode in format "HH:MM:SS:FF"
 */
export function secondsToTimecode(seconds, fps = 24) {
    if (typeof seconds !== 'number' || seconds < 0) {
        console.warn('Invalid seconds value:', seconds);
        return '00:00:00:00';
    }

    const totalFrames = Math.floor(seconds * fps);
    const frames = totalFrames % fps;
    const totalSeconds = Math.floor(totalFrames / fps);
    const secs = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const mins = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(mins)}:${pad(secs)}:${pad(frames)}`;
}
